import React from 'react';
import './FAQ.css';
import Accordion from './Accordion';

const FAQ = () => {
  return (
    <div className='faq-container'>
      <div className='faq-flex'>
        <div className='faq-left'>
          <div className='faq-header-text'>Frequently asked questions</div>
          <div className='faq-subText'>
            Everything you need to know about the product and pricing. Can’t
            find an answer? Please{' '}
            <span className='reach-out'>
              <a href='#'>reach out to us</a>
            </span>
          </div>
        </div>
        <div className='faq-right'>
          <Accordion />
        </div>
      </div>
    </div>
  );
};

export default FAQ;
